const getTimeRows = (min?: string | Date, max?: string | Date) => {
	const defaultMin = "Dec 31 1899 09:00:00";
	const defaultMax = "Dec 31 1899 19:00:00";

	const start = new Date(min || defaultMin);
	const end = new Date(max || defaultMax);

	const startDate = isNaN(start.getTime()) ? new Date(defaultMin) : start;
	const endDate = isNaN(end.getTime()) ? new Date(defaultMax) : end;

	const rows = [];
	let current = new Date(startDate);

	current.setMinutes(0, 0, 0);

	while (current <= endDate) {
		rows.push(
			current.toLocaleTimeString("en-IN", {
				hour: "2-digit",
				minute: "2-digit",
				hour12: true,
			}),
		);

		current.setHours(current.getHours() + 1);
	}

	return rows;
};
export const CalendarSkeleton = ({
	viewCounts = 7,
	min,
	max,
}: {
	viewCounts?: number;
	min?: string | Date;
	max?: string | Date;
}) => {
	// Fixed time rows
	const timeRows = getTimeRows(min, max);

	return (
		<div className="w-full">
			<div className="inline-block min-w-full  bg-gray-200/40">
				{/* Header Row */}
				<div className="flex">
					<div className="w-24 flex-shrink-0"></div>
					{Array.from({ length: viewCounts }).map((_, idx) => (
						<div key={idx} className="flex-1 min-w-[140px] px-4 py-3 text-center">
							<div className="h-4 bg-gray-200 rounded w-16 mx-auto animate-pulse"></div>
						</div>
					))}
				</div>

				{/* Time Rows */}
				{timeRows.map((time, rowIdx) => (
					<div key={rowIdx} className="flex bg-white">
						<div className="w-24 flex-shrink-0 px-3 py-3 text-xs text-gray-500 font-medium">{time}</div>
						{Array.from({ length: viewCounts }).map((_, colIdx) => (
							<div key={colIdx} className="flex-1 min-w-[140px] px-3 py-1 my-2 bg-gray-200/40 rounded-full">
								{/* Empty cell for skeleton */}
							</div>
						))}
					</div>
				))}
			</div>
		</div>
	);
};
